export default __webpack_public_path__ + "static/example-poster-e457bdbb83ce592455d91cfccd98c780.png";